var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-footer',{staticClass:"row flex-center text-white full-width footer"},[_c('div',{staticClass:"col-md-2 col-sm-12 q-py-md q-px-md"},[_c('div',{staticClass:"row justify-center",staticStyle:{"font-size":"11px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }